import { ReactElement } from 'react';

import * as Styled from './TitleBar.styles';
import { ITitleBarProps } from './TitleBar.types';

const TitleBar = ({ title, description, headerAreaComponent }: ITitleBarProps): ReactElement => (
  <Styled.TitleBar>
    <Styled.TextWrapper>
      <Styled.Title>{title}</Styled.Title>
      <Styled.Description>{description}</Styled.Description>
    </Styled.TextWrapper>
    <Styled.ComponentWrapper>{headerAreaComponent}</Styled.ComponentWrapper>
  </Styled.TitleBar>
);

export default TitleBar;
